module.exports = __webpack_public_path__ + "static/media/effiency.d23be73e.svg";